"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBroadcastNotificationDtoAudienceTypeEnum = void 0;
exports.instanceOfCreateBroadcastNotificationDto = instanceOfCreateBroadcastNotificationDto;
exports.CreateBroadcastNotificationDtoFromJSON = CreateBroadcastNotificationDtoFromJSON;
exports.CreateBroadcastNotificationDtoFromJSONTyped = CreateBroadcastNotificationDtoFromJSONTyped;
exports.CreateBroadcastNotificationDtoToJSON = CreateBroadcastNotificationDtoToJSON;
exports.CreateBroadcastNotificationDtoToJSONTyped = CreateBroadcastNotificationDtoToJSONTyped;
/**
 * @export
 */
exports.CreateBroadcastNotificationDtoAudienceTypeEnum = {
    All: 'all',
    Selected: 'selected'
};
/**
 * Check if a given object implements the CreateBroadcastNotificationDto interface.
 */
function instanceOfCreateBroadcastNotificationDto(value) {
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('audienceType' in value) || value['audienceType'] === undefined)
        return false;
    return true;
}
function CreateBroadcastNotificationDtoFromJSON(json) {
    return CreateBroadcastNotificationDtoFromJSONTyped(json, false);
}
function CreateBroadcastNotificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'],
        'message': json['message'],
        'deepLink': json['deepLink'] == null ? undefined : json['deepLink'],
        'audienceType': json['audienceType'],
        'userIds': json['userIds'] == null ? undefined : json['userIds'],
    };
}
function CreateBroadcastNotificationDtoToJSON(json) {
    return CreateBroadcastNotificationDtoToJSONTyped(json, false);
}
function CreateBroadcastNotificationDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'message': value['message'],
        'deepLink': value['deepLink'],
        'audienceType': value['audienceType'],
        'userIds': value['userIds'],
    };
}
